<select class="kgr-select" [value]="activeLocaleId" (change)="onLocaleSelected($event)" aria-label="Anzeigesprache wählen" i18n-aria-label>
  @for (localeId of locales; track localeId) {
    <option [value]="localeId" [selected]="localeId === activeLocaleId">
      {{ getLanguageName(localeId) }}
    </option>
  }
</select>
